import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [auth, setAuth] = useState({ loading: true, authenticated: false });

  const refresh = async () => {
    try {
      const { data } = await api.get("/auth/me");
      setAuth({ loading: false, ...data });
    } catch (e) {
      setAuth({ loading: false, authenticated: false });
    }
  };

  useEffect(() => {
    refresh();
  }, []);

  const logout = async () => {
    await api.post("/auth/logout");
    setAuth({ loading: false, authenticated: false });
  };

  return (
    <AuthContext.Provider value={{ ...auth, refresh, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
